export const AVAILABLE_MODELS = [
  {
    id: 'gpt-4o',
    name: 'GPT-4 Optimized',
    description: 'Latest optimized GPT-4 with enhanced performance and reliability',
    cost: 'High',
    benefits: 'Best reasoning, multimodal, latest features'
  },
  {
    id: 'gpt-4o-2024-08-06',
    name: 'GPT-4 Optimized (Aug 2024)',
    description: 'Stable GPT-4 model optimized for consistent performance',
    cost: 'High',
    benefits: 'Stable, reliable, excellent quality'
  },
  {
    id: 'gpt-4.5-preview-2025-02-27',
    name: 'GPT-4.5 Preview',
    description: 'Preview of next-gen GPT with advanced capabilities',
    cost: 'Very High',
    benefits: 'Cutting-edge features, superior reasoning'
  },
  {
    id: 'gpt-4-turbo-2024-04-09',
    name: 'GPT-4 Turbo',
    description: 'High-speed GPT-4 variant optimized for faster responses',
    cost: 'Medium',
    benefits: 'Fast responses, good quality, cost-effective'
  },
  {
    id: 'llama-3.3-70b-versatile',
    name: 'Llama 3.3 70B Versatile',
    description: 'Large 70B parameter open-source model for diverse tasks',
    cost: 'Medium',
    benefits: 'Open-source, versatile, good performance'
  },
  {
    id: 'llama-3.1-8b-instant',
    name: 'Llama 3.1 8B Instant',
    description: 'Fast 8B parameter model for quick, lightweight responses',
    cost: 'Low',
    benefits: 'Very fast, cost-effective, instant responses'
  },
  {
    id: 'deepseek-r1-distill-qwen-32b',
    name: 'DeepSeek R1 Qwen 32B',
    description: 'Distilled 32B model optimized for efficiency and reasoning',
    cost: 'Low',
    benefits: 'Efficient, good reasoning, budget-friendly'
  },
  {
    id: 'deepseek-r1-distill-llama-70b',
    name: 'DeepSeek R1 Llama 70B',
    description: 'Distilled 70B model for balanced performance and cost',
    cost: 'Medium',
    benefits: 'Balanced performance, good value, reliable'
  },
  {
    id: 'o3-mini-2025-01-31',
    name: 'O3 Mini',
    description: 'Lightweight model optimized for quick, simple tasks',
    cost: 'Very Low',
    benefits: 'Ultra-fast, minimal cost, simple tasks'
  }
] as const;

export type ModelType = typeof AVAILABLE_MODELS[number]['id'];

export const DEFAULT_MODEL = 'gpt-4o';
export const DEFAULT_TEMPERATURE = 0.1;